import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email.');
      return;
    }

    setLoading(true);

    try {
      // POST to your backend
      const response = await fetch('https://api.vectorvault.io/request_password_reset', {
        method: 'POST',
        headers: {
          'Authorization': 'expected_authorization_code',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || 'Failed to send reset email.');
      } else {
        setMessage('A password reset link has been sent to your email if it exists in our system.');
      }
    } catch (err) {
      console.error(err);
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div style={{ 
      backgroundColor: '#080808', 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'flex-start',
      padding: '80px 20px',
      fontFamily: "'Inter', sans-serif",
      color: '#ffffff',
    }}>
      <div style={{ 
        maxWidth: '420px', 
        width: '100%',
        backgroundColor: '#0d0d0d',
        border: '1px solid #1a1a1a',
        borderRadius: '16px',
        padding: '36px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
      }}>
        <h2 style={{ 
          marginBottom: '12px', 
          fontWeight: '700', 
          letterSpacing: '-0.02em',
          fontSize: '1.5rem',
        }}>Forgot Password</h2>
        <p style={{ color: '#999999', marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
          Enter your email address to receive a password reset link.
        </p>

        {error && <div style={{ 
          color: '#ff6b6b', 
          marginBottom: '16px', 
          padding: '10px 14px', 
          backgroundColor: 'rgba(255, 68, 68, 0.1)', 
          border: '1px solid rgba(255, 68, 68, 0.2)',
          borderRadius: '8px',
          fontSize: '14px',
        }}>{error}</div>}
        
        {message && <div style={{ 
          color: '#00d67a', 
          marginBottom: '16px', 
          padding: '10px 14px', 
          backgroundColor: 'rgba(0, 214, 122, 0.1)', 
          border: '1px solid rgba(0, 214, 122, 0.2)',
          borderRadius: '8px',
          fontSize: '14px',
        }}>{message}</div>}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#999999' }}>Email</label>
              <input 
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px 14px',
                  backgroundColor: '#111111',
                  border: '1px solid #222222',
                  borderRadius: '8px',
                  color: '#ffffff',
                  fontSize: '15px',
                  fontFamily: "'Inter', sans-serif",
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <button 
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#00d67a',
                color: '#000000',
                border: 'none',
                borderRadius: '8px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: "'Inter', sans-serif",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}

        {message && (
          <button
            onClick={handleBackToLogin}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#0d0d0d',
              color: '#ffffff',
              border: '1px solid #1a1a1a',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '500',
              cursor: 'pointer',
              fontFamily: "'Inter', sans-serif",
            }}
          >
            Back to Login
          </button>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
